// src/api/orderApi.js
import api from './index';

// 获取用户的历史订单记录
export const fetchOrderHistory = ({ user_key }) => api.post('/testapi/payment/payment_controller/get_order_history', {
  user_key // 发送 { user_key: "some-user-key-value" }
});


// 获取用户的历史订单记录
export const fetchOrderHistoryByUid = ({ uid }) => api.post('/testapi/payment/payment_controller/get_order_history_by_uid', {
  uid // 发送 { user_key: "some-user-key-value" }
});



// 获取单个订单详情（可选，视需求添加）
export const fetchOrderById = ({ orderId }) => api.post('/testapi/order/order_controller/get_order_by_id', {
  orderId // 发送 { orderId: "some-order-id" }
});



// 获取单个订单详情（可选，视需求添加）
export const fetchOrderByOrderId = ({ orderId }) => api.post('/testapi/payment/product_controller/getProductByOrdedrID', {
  orderId // 发送 { orderId: "some-order-id" }
});

// 提交售后客服请求（通过邮件发送）
export const sendAfterSaleEmail = ({ orderNo, type, question, desc, email, uid }) => {
  // 参数校验
  if (!orderNo || !type || !question || !desc || !email || !uid) {
    return Promise.reject(new Error('orderNo, type, question, desc, email, and uid are required for after-sale email request'));
  }

  // 构造请求体
  const requestBody = {
    orderNo,  // 订单编号
    type,     // 产品类型
    question, // 问题描述
    desc,     // 详细描述
    email,    // 用户邮箱
    uid,      // 用户ID
  };

  // 发送 POST 请求
  return api.post('/testapi/email/email_controller/send_after_sale_email', requestBody);
};



// 新增：获取免费测试链接（适用于所有类型）
export const fetchTestUrl = ({ user_key, type }) => {
  // 参数校验
  if (!user_key || !type) {
    return Promise.reject(new Error('user_key and type are required for fetching test URL'));
  }

  // 构造请求体
  const requestBody = {
    user_key,  // 用户标识
    type       // 测试类型（如 "grok" 或其他类型）
  };

  // 发送 POST 请求
  return api.post('/testapi/payment/order_controller/get_claude_test_url', requestBody);
};